import { useState, useEffect } from "react";

const mobileScreenWidth = 481;

function checkIsMobileScreen(width: number): boolean {
    return width < mobileScreenWidth;
}

export const useIsMobile = () => {
    const [isMobileScreen, setIsMobileScreen] = useState(
        checkIsMobileScreen(window.innerWidth)
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobileScreen(checkIsMobileScreen(window.innerWidth));
        };

        window.addEventListener("resize", handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return isMobileScreen;
};
